<template>
  <div class="container">
    <h4>{{ title }}</h4>
    <h4>{{ title2 }}</h4>
    <h6 class="mb-4" style="text-align:right;">{{ title3 }}</h6>
    <div class="row">
      <div class="col-md-12 col-12 mb-2">
        <div class="form-row">
          <label class="col-6">Applicable Standard: </label>
          <select class="col-6" v-model="appStadard" @change="onChange()">
            <option value="0">API 610</option>
            <option value="1">ANSI B73.1</option>
            <option value="2">ISO 5199</option>
            <option value="3">Hydraulic Institude (HI)</option>
          </select>
          <label class="col-6"><span style="color:red;">*</span> Rated Flowrate (m&sup3/hr): </label>
          <input type="number" class="col-6 form-control" v-model="flowrate" :disabled="disabled">
          <label class="col-6"><span style="color:red;">*</span> Differential Head (m): </label>
          <input type="number" class="col-6 form-control" v-model="diffHead" :disabled="disabled">
          <label class="col-6"><span style="color:red;">*</span> Density (specific gravity): </label>
          <input type="number" class="col-6 form-control" v-model="density" :disabled="disabled">
          <label class="col-6">Rated Discharge Pressure (barg): </label>
          <input type="number" class="col-6 form-control" v-model="rateDisPrs" :disabled="disabled">
          <label class="col-6">Max. Suction Pressure (barg): </label>
          <input type="number" class="col-6 form-control" v-model="sucPrs" :disabled="disabled">
          <label class="col-6">MAWP (10% margin) : </label>
          <input type="number" class="col-6 form-control" v-model="mawp" :disabled="disabled">
          <label class="col-6">Temperature (&#8451;): </label>
          <input type="number" class="col-6 form-control" v-model="temprature" :disabled="disabled">
          <label class="col-6">NPSH Margin: </label>
          <select class="col-6" v-model="npsh_margin" :disabled="disabled">
            <option value="0">-- Please Select --</option>
            <option value="1">Insufficient</option>
            <option value="2">Ample</option>
          </select>
          <label class="col-6">Sump Service: </label>
          <select class="col-6" v-model="sump_service" :disabled="disabled">
            <option value="0">-- Please Select --</option>
            <option value="1">Wet Pit / Close Drain Drum</option>
            <option value="2">Wet Pit Not Avalible</option>
          </select>
          <label class="col-6">Rotating Speed (rpm): </label>
          <select class="col-6" v-model="rpm" :disabled="disabled">
            <option value="0">-- Please Select --</option>
            <option value="750">750 (50 Hz)</option>
            <option value="900">900 (60 Hz)</option>
            <option value="1000">1000 (50 Hz)</option>
            <option value="1200">1200 (60 Hz)</option>
            <option value="1500">1500 (50 Hz)</option>
            <option value="1800">1800 (60 Hz)</option>
            <option value="3000">3000 (50 Hz)</option>
            <option value="3600">3600 (60 Hz)</option>
            <option value="9999">>3600 (60 Hz) / >3000(50 Hz)</option>
          </select>
        </div>
        <br>
        <b-button variant="primary" @click="onSubmit()">Select</b-button>
        <b-button @click="onClear()">Clear</b-button>
        <br><hr>
        <label class="col-md-3 col-6 result">Result:</label>
        <span class="col-md-9 col-6" style="color:red">{{strResult}}</span><br>
        <label class="col-md-3 col-8 result ">Recommanded Selection:</label>
        <span class="col-md-9 col-4" style="color:red">{{bestResult}}</span><br>
        <label class="col-md-3 col-8 result">Hydraulic Power (kW):</label>
        <span class="col-md-9 col-4" style="color:green">{{hydraulicPow}}</span><br>
        <label class="col-md-3 col-8 result">Specific Speed (Metric):</label>
        <span class="col-md-9 col-4" style="color:green">{{specificSpeed}}</span><br>
        <label class="col-md-3 col-8 result">Weight (kg):</label>
        <span class="col-md-9 col-4" style="color:green">{{weight}}</span><br>
        <img id="imgPump" v-bind:src="(bestResult && bestResult.length<10) ? require('../assets/'+bestResult+'.jpg'):''">
      </div>
    </div>
  </div>
</template>

<script>
  const names = ['OH1', "OH2", 'OH6', 'BB1', 'BB2',
                  'BB2', 'BB2', 'BB2', 'BB3', 'BB4',
                  'BB5', 'VS1', 'VS2', 'VS3', 'VS4_VS5',
                  'VS6', 'VS6', 'VS6', 'VS6'];
  const priority = [0.5, 0.7, 0.9, 0.8, 0.8,
                    0.8, 0.8, 0.8, 1.7, 1.8,
                    1.9, 2, 3, 4, 1,
                    2, 2, 2, 2];
  const factors = [20000, 30000, 60000, 54000, 54000,
    54000, 54000, 54000, 60000, 40000,
    40000, 35000, 40000, 40000, 22000,
    35000, 35000, 35000, 35000];
export default {
  name: 'Home',
  data () {
    return {
      title: 'Program based on ',
      title2: '"An Empirical Process and Utility Pump Classification Type Selection Table"',
      title3: '- Shenk S.H.Chiu 2019',
      flags: Array(names.length).fill(true),
      appStadard: 0,
      flowrate: '',
      diffHead: '',
      rateDisPrs: '',
      sucPrs: '',
      mawp: '',
      density: '',
      temprature: '',
      npsh_margin: 0,
      sump_service: 0,
      rpm: 0,
      disabled: false,
      strResult: '',
      bestResult: '',
      hydraulicPow: 0,
      specificSpeed: 0,
      weight: 0
    }
  },
  methods: {
    onChange() {
      //this.disabled = (this.appStadard == 1) || (this.appStadard == 2);
    },
    onClear() {
      this.flowrate = '';
      this.diffHead = '';
      this.rateDisPrs = '';
      this.sucPrs = '';
      this.mawp = '';
      this.density = '';
      this.temprature = '';
      this.npsh_margin = this.sump_service = this.rpm = 0;
      this.strResult = this.bestResult = '';
      this.hydraulicPow = 0;
      this.specificSpeed = 0;
      this.weight = 0;
      this.flags = Array(names.length).fill(true);
    },
    onSubmit() {
      this.hydraulicPow = 0;
      this.specificSpeed = 0;
      this.weight = 0;
      this.strResult = this.bestResult = '';

      //Applicable Standard
      if ((this.appStadard == 1) || (this.appStadard == 2)) {
        this.flags = Array(names.length).fill(false);
        this.flags[0] = true;
      } else {
        this.flags = Array(names.length).fill(true);
        if (this.appStadard == 0) {
          this.flags[0] = this.flags[9] = false;
        }
      }

      //Flowrate Limit
      if (this.flowrate) {
        if (this.flowrate > 4000) {
          this.flags[0] = this.flags[1] = this.flags[2] = this.flags[4] =
            this.flags[5] = this.flags[6] = this.flags[7] = this.flags[8] =
            this.flags[9] = this.flags[10] = this.flags[12] = this.flags[14] =
            this.flags[15] = this.flags[16] = this.flags[17] = this.flags[18] = false;
        } else if (this.flowrate > 3000) {
          this.flags[0] = this.flags[1] = this.flags[2] = this.flags[4] =
            this.flags[5] = this.flags[6] = this.flags[8] = this.flags[9] =
            this.flags[10] = this.flags[14] = this.flags[15] = this.flags[16] =
            this.flags[17] = this.flags[18] = false;
        } else if (this.flowrate > 2000) {
          this.flags[0] = this.flags[1] = this.flags[2] = this.flags[4] =
            this.flags[5] = this.flags[8] = this.flags[9] = this.flags[10] =
            this.flags[14] = this.flags[15] = this.flags[16] = this.flags[17] = false;
        } else if (this.flowrate > 1000) {
          this.flags[0] = this.flags[1] = this.flags[2] = this.flags[4] =
            this.flags[8] = this.flags[9] = this.flags[10] = this.flags[12] =
            this.flags[13] = this.flags[14] = this.flags[15] = this.flags[16] = false;
        } else if (this.flowrate > 200) {
          this.flags[2] = this.flags[3] = this.flags[12] = this.flags[13] = false;
        } else {
          this.flags[3] = this.flags[12] = this.flags[13] = false;
        }
      }

      //Differential Head Limit
      if (this.diffHead) {
        if (this.diffHead > 600) {
          this.flags[0] = this.flags[1] = this.flags[2] = this.flags[3] =
            this.flags[4] = this.flags[5] = this.flags[6] = this.flags[7] =
            this.flags[11] = this.flags[12] = this.flags[13] = this.flags[14] =
            this.flags[15] = this.flags[16] = this.flags[17] = this.flags[18] = false;
        } else if (this.diffHead > 500) {
          this.flags[0] = this.flags[1] = this.flags[2] = this.flags[3] =
            this.flags[4] = this.flags[5] = this.flags[6] = this.flags[7] =
            this.flags[11] = this.flags[12] = this.flags[13] = this.flags[14] =
            this.flags[16] = this.flags[17] = this.flags[18] = false;
        } else if (this.diffHead > 400) {
          this.flags[0] = this.flags[1] = this.flags[3] = this.flags[5] =
            this.flags[6] = this.flags[7] = this.flags[11] = this.flags[12] =
            this.flags[13] = this.flags[14] = this.flags[17] = this.flags[18] = false;
        } else if (this.diffHead > 300) {
          this.flags[0] = this.flags[1] = this.flags[3] = this.flags[6] =
            this.flags[7] = this.flags[8] = this.flags[9] = this.flags[10] =
            this.flags[11] = this.flags[12] = this.flags[13] = this.flags[14] =
            this.flags[18] = false;
        } else if (this.diffHead > 200) {
          this.flags[0] = this.flags[3] = this.flags[7] = this.flags[8] =
            this.flags[9] = this.flags[10] = this.flags[12] = this.flags[13] =
            this.flags[14] = this.flags[18] = false;
        } else {
          this.flags[8] = this.flags[9] = this.flags[10] = false;
        }
      }

      //Rated Discharge Pressure
      if (this.rateDisPrs) {
        if (this.rateDisPrs > 100) {
          this.flags[0] = this.flags[1] = this.flags[2] = this.flags[3] =
            this.flags[4] = this.flags[5] = this.flags[6] = this.flags[7] =
            this.flags[8] = this.flags[11] = this.flags[12] = this.flags[13] =
            this.flags[14] = this.flags[15] = this.flags[16] = this.flags[17] =
            this.flags[18] = false;
          console.log(this.flags);
        } else if (this.rateDisPrs > 19) {
          this.flags[0] = false;
        }
      }

      //Suction Pressure
      if (this.sucPrs) {
        if (this.sucPrs > 5) {
          this.flags[0] = false;
        }
      }

      //MAWP
      if (this.mawp) {
        if (this.mawp > 40) {
          this.flags[0] = this.flags[3] = this.flags[11] = this.flags[12] =
            this.flags[13] = this.flags[14] = false;
        }
      }

      //Design Temperature
      if (this.temprature) {
        if (this.temprature > 200) {
          this.flags[0] = this.flags[2] = this.flags[3] = this.flags[8] =
            this.flags[9] = this.flags[11] = this.flags[12] = this.flags[13] =
            this.flags[14] = false;
        } else if (this.temprature > 150) {
          this.flags[0] = false;
        } else if (this.temprature > -40) {
        } else if (this.temprature > -50) {
          this.flags[0] = this.flags[2] = this.flags[3] = this.flags[8] =
            this.flags[9] = this.flags[10] = this.flags[11] = this.flags[12] =
            this.flags[13] = this.flags[14] = false;
        } else {
          this.flags[0] = this.flags[1] = this.flags[2] = this.flags[3] =
            this.flags[4] = this.flags[5] = this.flags[6] = this.flags[7] =
            this.flags[8] = this.flags[9] = this.flags[10] = this.flags[11] =
            this.flags[12] = this.flags[13] = this.flags[14] = false;
        }
      }

      //Density
      if (this.density) {
        if (this.density < 0.7) {
          this.flags[0] = this.flags[2] = this.flags[3] = this.flags[8] =
            this.flags[9] = this.flags[12] = this.flags[13] = false;
        }
      }

      //NPSH Margin
      if (this.npsh_margin) {
        if (this.npsh_margin == 1) {
          this.flags[0] = this.flags[1] = this.flags[2] = this.flags[8] =
            this.flags[9] = this.flags[10] = this.flags[12] = this.flags[13] = false;
        } else if (this.npsh_margin == 2) {
          this.flags[15] = this.flags[16] = this.flags[17] = this.flags[18] = false;
        }
      }

      //Sump Service
      if (this.sump_service == 1) {
        this.flags[0] = this.flags[1] = this.flags[2] = this.flags[3] =
          this.flags[4] = this.flags[5] = this.flags[6] = this.flags[7] =
          this.flags[8] = this.flags[9] = this.flags[10] = this.flags[15] =
          this.flags[16] = this.flags[17] = this.flags[18] = false;
      } else if (this.sump_service == 2) {
        this.flags[0] = this.flags[1] = this.flags[2] = this.flags[3] =
          this.flags[4] = this.flags[5] = this.flags[6] = this.flags[7] =
          this.flags[8] = this.flags[9] = this.flags[10] = this.flags[11] =
          this.flags[12] = this.flags[13] = this.flags[14] = false;
      }

      //Rotating Speed
      if (this.rpm) {
        if (this.rpm <= 1200) {
          this.flags[2] = this.flags[8] = this.flags[9] = this.flags[10] =
            this.flags[12] = this.flags[14] = false;
        } else if (this.rpm <= 1800) {
          this.flags[2] = this.flags[8] = this.flags[9] = this.flags[10] = false;
        } else if (this.rpm == 9999) {
          this.flags[0] = this.flags[1] = this.flags[3] = this.flags[4] =
            this.flags[5] = this.flags[6] = this.flags[7] = this.flags[9] =
            this.flags[11] = this.flags[12] = this.flags[13] = this.flags[14] =
            this.flags[15] = this.flags[16] = this.flags[17] = this.flags[18] = false;
        }
      }
      
      this.hydraulicPow = ((this.flowrate * this.density * 0.98 * this.diffHead) / 360).toFixed(0);

      console.log(this.flags);
      var first = true;
      var lowest = 999;
      var fac = 0;
      for (var i = 0; i < this.flags.length; i++) {
        if (this.flags[i] && this.strResult.indexOf(names[i])<0 ) {
          if (!first) {
            this.strResult += ', '
          } else {
            first = false;
          }
          this.strResult += names[i];
          if (priority[i] < lowest) {
            console.log(names[i], this.hydraulicPow);
            if ((names[i] == 'VS4_VS5') || (names[i] == 'OH1')) {
              if (this.hydraulicPow <= 100) {
                lowest = priority[i];
                this.bestResult = names[i];
                fac = factors[i];
              }
            } else if (names[i] == 'OH2') {
              if (this.hydraulicPow <= 200) {
                lowest = priority[i];
                this.bestResult = names[i];
                fac = factors[i];
              }
            } else {
              lowest = priority[i];
              this.bestResult = names[i];
              fac = factors[i];
            }
          }
        }
      }

      this.specificSpeed = (this.flowrate && this.rpm && this.diffHead) ?
        (this.rpm * Math.sqrt(this.flowrate) / Math.pow(this.diffHead, 3 / 4)).toFixed(0) : 0;
      this.weight = (this.hydraulicPow && this.rpm && fac) ?
        (Math.pow(this.hydraulicPow, 1 / 3) / Math.sqrt(this.rpm) * fac).toFixed(0) : 0;

      if (!this.bestResult) {
        this.bestResult = "Please consult with AE type person.";
      }

    }
  },
  mounted() {
    //console.log(this.flags)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  s
h1, h2, h3,
h4, h5 {
  font-weight:600;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
label, select, input {
  margin: 5px 0;
}
label {
  text-align:right;
}
hr {
  background: none repeat scroll 0 0 #000000;
  border: thin none;
  height: 2px;
}
.result {
  font-weight:600;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue